import {
  CreditsConsumer,
  AuthorisationConsumer,
  RequestProvider
} from '@shootsta/common-react';
import FlexPurchasePaymentSuccessModalComponent from '../components/FlexPurchasePaymentSuccessModal';
import InvoicesContext, {
  InvoicesContextProvider
} from '../../../context/InvoicesContext';
import { getPaymentInvoice } from '../../../api';

interface FlexPurchasePaymentSuccessModalProps {
  visible: boolean;
  orderId: string;
  purchasedCredit: number;
  onClose: (args: boolean) => void;
}

function FlexPurchasePaymentSuccessModal(
  props: FlexPurchasePaymentSuccessModalProps
) {
  return (
    <AuthorisationConsumer>
      {({ selectedOrganisation: { organisationId } }) => (
        <CreditsConsumer>
          {({ state: { contractItemBalance } }) => (
            <RequestProvider
              requests={{
                getPaymentInvoice: getPaymentInvoice()
              }}
            >
              {({ getPaymentInvoice }) => (
                <InvoicesContextProvider getPaymentInvoice={getPaymentInvoice}>
                  <InvoicesContext.Consumer>
                    {({ actions: { openInvoices } }) => (
                      <FlexPurchasePaymentSuccessModalComponent
                        contractItemBalance={contractItemBalance}
                        organisationId={organisationId}
                        onViewInvoice={openInvoices}
                        {...props}
                      />
                    )}
                  </InvoicesContext.Consumer>
                </InvoicesContextProvider>
              )}
            </RequestProvider>
          )}
        </CreditsConsumer>
      )}
    </AuthorisationConsumer>
  );
}

export default FlexPurchasePaymentSuccessModal;
